import { Component, OnDestroy, Inject } from '@angular/core';
import { PlatformModule } from '../../models/platform-module';
import { Subject } from 'rxjs';
import { Environment } from '../../models/environment';
import { EnvironmentService } from '../../services/environment.service';

@Component({
    selector: 'app-oncall-navmenu',
    templateUrl: '../../navmenu/navmenu.component.html',
    styleUrls: ['../../navmenu/navmenu.component.css'],
    standalone: false
})
export class OnCallNavmenuComponent implements OnDestroy {
  environment: Environment;
  mods: Array<PlatformModule> = [];
  onCallEnabled: boolean;
  private readonly _destroying$ = new Subject<void>();

  get enabledMods() {
    return this.mods.filter((item) => item.enabled);
  }

  constructor(
    @Inject(EnvironmentService) private readonly environmentService: EnvironmentService,
  ) {
    this.environment = this.environmentService.getEnvironment();
    this.onCallEnabled = this.environment.featureToggles.onCallEnabled === 'true';
    this.mods = [
      {
        name: 'Alerts',
        route: 'oncall/alerts',
        enabled: this.onCallEnabled,
        iconClass: "material-symbols-outlined",
        icon: "notifications_active",
      },
      {
        name: 'Teams',
        route: 'oncall/teams',
        enabled: this.onCallEnabled,
        iconClass: "material-symbols-outlined",
        icon: "groups",
      },
      {
        name: 'Members',
        route: 'oncall/members',
        enabled: this.onCallEnabled,
        iconClass: "material-symbols-outlined",
        icon: "person",
      }
    ];
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
